import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import { A } from '../../base/typography';

export const Heading = styled.div`
	font-size: 3rem;
	font-weight: 700;
	margin: 2rem 0;
	color: ${theme.colors.black};

	span {
		display: block;
		font-size: 1.5rem;
		line-height: 0rem;
		text-transform: uppercase;
		color: ${theme.colors.gray};
	}

	${media.mobileAndTabletOnly`
		display: none;
	`}
`;

export const Navigation = styled.div`
	${media.mobileAndTabletOnly`
		margin: 0 -4rem;
	`}
`;

export const LinkWrapper = styled.div`
	display: flex;
	flex-direction: column;
	white-space: nowrap;
	overflow: auto hidden;
	${media.mobileAndTabletOnly`
		padding: 2rem;
		flex-direction: row
	`};
`;

export const Option = styled(NavLink)`
	&.${props => props.activeClassName} {
		color: ${theme.colors.primary};
	}
	cursor: pointer;
	display: flex;
	align-items: center;
	font-weight: 400;
	color: ${theme.colors.black};

	svg {
		margin-right: 1.5rem;
		width: 2rem;
		height: auto;
		fill: ${theme.colors.gray};
	}
	${media.desktopSmall`
		margin-bottom: 1.5rem;
	`}

	${media.mobileAndTabletOnly`
		display: flex;
		padding: 0 2rem;
		margin-right: 1rem;
	`}

	&:hover {
		color: ${theme.colors.primary};
	}
`;

export const Logout = styled(A)`
	&.${props => props.activeClassName} {
		color: ${theme.colors.primary};
	}
	cursor: pointer;
	display: flex;
	align-items: center;
	font-weight: 400;
	margin-top: 1.5rem;
	color: ${theme.colors.primary};

	svg {
		margin-right: 1.5rem;
		width: 2rem;
	}

	&:hover {
		color: ${theme.colors.primaryDark};
	}

	${media.mobileAndTabletOnly`
		display: none;
	`}
`;
